import React, { useEffect } from "react"
import { useCombinations } from "./COMBINATION_CONTENT"
import { COMBINATION_PROPS } from "./interface"
import { CombinationContainer, Row } from "./CombinationsStyled"
import useSound from "use-sound"
import combinationSFX from "../../../assets/audioL/combinationWin1SFX.mp3"

export default function Combinations({
  winType,
  audio,
  lastCardRotated,
  state,
  localSound,
  coefs,
}: COMBINATION_PROPS) {
  const [playWinCombinationSFX] = useSound(combinationSFX, {
    volume: parseFloat(audio),
  })
  const [combArray] = useCombinations(coefs && coefs.coefs[0])

  useEffect(() => {
    if (
      winType > 0 &&
      localSound &&
      lastCardRotated &&
      state !== 4 &&
      state !== 7
    ) {
      playWinCombinationSFX()
    }
  }, [winType, localSound, playWinCombinationSFX, lastCardRotated, state])

  return (
    <CombinationContainer>
      {combArray.map((item: any, id: any) => (
        <Row
          key={id}
          className="row"
          isWin={item.win === winType && lastCardRotated}
        >
          <p>{item.title}</p>
          <p>{item.coef}X</p>
        </Row>
      ))}
    </CombinationContainer>
  )
}
